import React, { useState, useCallback } from 'react'

interface ImageWithFallbackProps {
  src?: string | null
  alt: string
  fallback?: string
  className?: string
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
}

const DEFAULT_FALLBACK = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"%3E%3Crect fill="%23e5e7eb" width="400" height="300"/%3E%3Ctext fill="%239ca3af" font-family="system-ui" font-size="14" text-anchor="middle" x="200" y="155"%3EImage not available%3C/text%3E%3C/svg%3E'

export const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt,
  fallback = DEFAULT_FALLBACK,
  className = '',
  objectFit = 'cover'
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  const handleLoad = useCallback(() => {
    setIsLoading(false)
  }, [])

  const handleError = useCallback(() => {
    setIsLoading(false)
    setHasError(true)
  }, [])

  const imageSrc = hasError || !src ? fallback : src

  return (
    <div className={`relative ${className}`}>
      {isLoading && !hasError && src && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse rounded" />
      )}
      <img
        src={imageSrc}
        alt={alt}
        className={`w-full h-full object-${objectFit} ${isLoading && !hasError && src ? 'opacity-0' : 'opacity-100'} transition-opacity duration-200`}
        onLoad={handleLoad}
        onError={handleError}
      />
    </div>
  )
}
